/**
 * 用户某次答题的记录
 */

import React, {useState} from 'react';
import { useRequest, useBrowserTitle } from 'hook/index';
import { Item, ItemView } from './Item';
import styles from './Record.module.scss';
import qs from 'query-string';
import {BlockEmpty, BlockLoading} from 'component/BlockLoading/BlockLoading';
import { ExerciseRecordList } from 'component/ExerciseRecordList/ExerciseRecordList';

interface BackendData {
    list: Item[];
    skill: {
        // 技能中文名
        appNameCh: string;
    };
}

export default function Record() {
    const [recordId] = useState<string>(function() {
        const searchConf = qs.parse(window.location.search.substring(1));
        return (searchConf.sessionid || '') as string;
    });
    const {
        loading,
        data,
    } = useRequest<BackendData>({
        url: `/wx/exercise/record?recordId=${encodeURIComponent(recordId)}`,
        method: 'GET',
        defaultData: { list: [], skill: { appNameCh: ''} },
        defaultIsLoading: true,
    });
    return (
        <ExerciseRecordList loading={loading} data={data} pageTitleSuffix="答题记录" />
    );
    // let pageTitle = '答题记录';
    // if (data.skill && data.skill.appNameCh) {
    //     pageTitle = `${data.skill.appNameCh}-答题记录`;
    // }
    // useBrowserTitle(pageTitle);
    // let content = null;
    // if (!loading) {
    //     if (data.list.length < 1) {
    //         content = (<BlockEmpty/>);
    //     } else {
    //         content = (
    //             <div>
    //                 {
    //                     data.list.map(function(obj: Item, index: number){
    //                         return (<ItemView key={index} item={obj} />);
    //                     })
    //                 }
    //             </div>
    //         );
    //     }
    // }
    // return (
    //     <div>
    //         { loading && <BlockLoading />}
    //         { content }
    //     </div>
    // );
}
